import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { forgetPassword } from "../../store/actions/authAction";
import { createTheme, ThemeProvider } from "@mui/material";
import { Button, Form, Col, Spinner, Row, Container } from "reactstrap";
import InputFields from "../../components/InputFields";
import AuthHeader from "../../components/AuthHeader";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [email, setEmail] = useState("");
  let { forgetLoading } = useSelector((state) => state.user);
  const { darkMode, color } = useSelector((state) => state.global);
  const inputColor = darkMode ? "#ffffff" : "rgb(101 92 92)";
  const theme = createTheme({
    palette: {
      secondary: {
        main: `${color ? color : "#000000"}`,
      },
    },
  });

  const labelProps = {
    style: {
      color: darkMode ? "#ffffff" : "rgb(101 92 92)",
    },
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      dispatch(
        forgetPassword(email, () => {
          history.push("/auth");
        })
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      forgetPassword(email, () => {
        history.push("/auth");
      })
    );
  };

  return (
    <>
      <Container className="py-5">
        <Row className="d-flex flex-column justify-content-center align-items-center">
          <Col className="d-flex justify-content-center align-items-center">
            <Form
              className={darkMode ? "px-3 pay-with-card" : "px-3"}
              onSubmit={handleSubmit}
              onKeyDown={handleKeyDown}
            >
              <Row className="d-flex flex-column justify-content-center align-items-center mb-2">
                <Col>
                  <AuthHeader darkMode={darkMode} title={"Forget Password"} />

                  <div className="text-center text-muted mt-5">
                    <p>
                      No worries, we will send you an email to reset your
                      password.
                    </p>
                  </div>
                </Col>
              </Row>
              <ThemeProvider theme={theme} style={{ maxWidth: "200px" }}>
                <InputFields
                  labelName="Enter your NextEats account email"
                  value={email}
                  type={"email"}
                  name={"email"}
                  labelProps={labelProps}
                  inputColor={inputColor}
                  handleChangeData={(e) => setEmail(e.target.value)}
                  darkMode={darkMode}
                />
              </ThemeProvider>
              {}
              <Button
                className="py-3 w-100 auth__btn"
                color="danger"
                type="submit"
                disabled={!email}
              >
                {forgetLoading ? <Spinner size="md" /> : "Reset Password"}
              </Button>
              {}

              <div className="mx-2 py-2 d-flex justify-content-end text-right">
                <Link to="/auth">Back to Login</Link>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ForgetPassword;
